import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { specsEditorActions } from "../../common/slices/specsEditor/slice";
import type { SpecsLayer, SpecsLayerModelPath } from "./types";

type LayerModelPathUpdater = (
  path: SpecsLayerModelPath | null,
  layer: SpecsLayer
) => SpecsLayerModelPath | null;

export function useSpecsEditorLayerModelPaths(layers: SpecsLayer[]) {
  const dispatch = useDispatch();

  return useCallback(
    (updater: LayerModelPathUpdater) => {
      const nextModelPaths = Object.fromEntries(
        layers.map((layer) => {
          const currentPath = layer.modelLayerPath
            ? layer.modelLayerPath
            : null;
          return [layer.id, updater(currentPath, layer)];
        })
      );

      dispatch(specsEditorActions.setLayerModelPaths(nextModelPaths));

      return layers.map((layer) => ({
        ...layer,
        modelLayerPath: nextModelPaths[layer.id],
      }));
    },
    [dispatch, layers]
  );
}
